import { createUseStyles } from 'react-jss'

export default createUseStyles({
  button: {
    fontFamily: 'BentonSansRegular',
    padding: ({ icon }) => icon ? 'initial' : '25px 30px'
  }
})
